// ═══════════════════════════════════════════════════════════════
// API: Préstamos - CORREGIDO
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const prestamosAPI = {
  /**
   * Obtener todos los préstamos de la compañía actual
   */
  getAll: async (params = {}) => {
    // Obtener companyId del localStorage
    const companyId = localStorage.getItem('companyId');
    
    if (!companyId) {
      throw new Error('No hay compañía seleccionada');
    }
    
    const response = await api.get(`/prestamos/company/${companyId}`, { params });
    return response.data;
  },

  /**
   * Obtener préstamo por ID
   */
  getById: async (id) => {
    const response = await api.get(`/prestamos/${id}`);
    return response.data;
  },

  /**
   * Obtener préstamos de un empleado
   */
  getByEmployee: async (employeeId) => {
    const response = await api.get(`/prestamos/employee/${employeeId}`);
    return response.data;
  },

  /**
   * Crear préstamo
   */
  create: async (data) => {
    const response = await api.post('/prestamos', data);
    return response.data;
  },

  /**
   * Actualizar préstamo
   */
  update: async (id, data) => {
    const response = await api.put(`/prestamos/${id}`, data);
    return response.data;
  },

  /**
   * Eliminar préstamo
   */
  delete: async (id) => {
    const response = await api.delete(`/prestamos/${id}`);
    return response.data;
  },

  /**
   * Registrar pago extraordinario
   */
  registrarPagoExtraordinario: async (prestamoId, data) => {
    const response = await api.post(`/prestamos/${prestamoId}/pago-extraordinario`, data);
    return response.data;
  },

  /**
   * Obtener resumen/estadísticas (si existe en backend)
   */
  getSummary: async () => {
    const companyId = localStorage.getItem('companyId');
    if (!companyId) {
      throw new Error('No hay compañía seleccionada');
    }
    const response = await api.get(`/prestamos/company/${companyId}/summary`);
    return response.data;
  }
};

export default prestamosAPI;
